import { type RouteObject } from "react-router-dom";

import { AUTH_ROLES } from "api/common/types/auth.types";
import DashboardRedirect from "features/memberPortal/reports/components/DashboardRedirect";
import ExpandedEcrAssignmentReport from "features/memberPortal/reports/ECR/ExpandedEcrAssignment.screen";
import QuicksightReport from "features/memberPortal/reports/QuicksightReport.screen";
import ReportsCenter from "features/memberPortal/reports/ReportsCenter.screen";
import AuthenticatedRoute from "routing/AuthenticatedRoute";

const { NIAP, VALIDATOR } = AUTH_ROLES;

const reportRoutes: RouteObject[] = [
  {
    path: "reports",
    element: <AuthenticatedRoute allowedRoles={[NIAP, VALIDATOR]} />,
    children: [
      {
        index: true,
        element: <ReportsCenter />,
      },
      {
        path: "expanded-ecr-assignment-report",
        element: <ExpandedEcrAssignmentReport />,
      },
      {
        path: ":id",
        element: <AuthenticatedRoute allowedRoles={[NIAP]} />,
        children: [
          { index: true, element: <DashboardRedirect /> },
          { path: ":dashboardSlug", element: <QuicksightReport /> },
        ],
      },
    ],
  },
];

export default reportRoutes;
